var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"ordenar"},[_c('i',{staticClass:"icon-up",class:_vm.active_desc ? 'active' : '',on:{"click":function($event){return _vm.ordenar('DESC')}}}),_c('i',{staticClass:"icon-down",class:_vm.active_asc ? 'active' : '',on:{"click":function($event){return _vm.ordenar('ASC')}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }